import { LEAD_URL } from "../utils/constants";

class LeadApi {
  // constructor({ baseUrl }) {
  //   MAIN_URL = baseUrl;
  // }

  _checkResponse(res) {
    if (res.ok) {
      return res.json();
    } else {
      const statusCode = res.status;
      return res.json().then((res) => {
        return Promise.reject({
          statusCode: statusCode,
          message: res.msg,
          detail: res.detail,
        });
      });
    }
  }

  
  sendFindWatches({ item_name, name, email, phone }) {
    let params = {};
    if (name) params.name = name;
    if (email) params.email = email;
    if (phone) params.phone = phone;
    if (item_name) params.item_name = item_name;

    return fetch(
      `${LEAD_URL}/SANY_FIND_WATCHES/?` +
      new URLSearchParams(params),
      {
        method: "POST",
        // credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    ).then(this._checkResponse);
  }

}



const leadApi = new LeadApi({
  baseUrl: LEAD_URL,
});

export default leadApi;
